import { getConfluenceReferenceObject } from './confluence';
import type { ReferenceObject, ReferenceObjectInput } from './types';

// Resolves a reference object from a context identifier. Only Confluence exists
// today, so we delegate directly; add explicit dispatch with the next resolver.
export const getReferenceObjectFromContextIdentifier = (
	input: ReferenceObjectInput,
): ReferenceObject | undefined => getConfluenceReferenceObject(input);
